import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PreferencesService } from '@src/core/services';

@Component({
  selector: 'app-chat-public-page',
  templateUrl: './chat-public-page.component.html',
  styleUrls: ['./chat-public-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatPublicPageComponent {
  readonly preferences = inject(PreferencesService);
}
